// src/services/email-manager.ts

import {
  ChangePasswordRequest,
  UpdateMyAccountRequest,
  UserModel,
} from '@/types';
import type { ApiResponse } from '@/types/api/response.api';
import http from '../01_axios';
import { API_LIST } from './url';

const update = (data: UpdateMyAccountRequest): Promise<ApiResponse> =>
  http.post(API_LIST.UPDATE_USER, data);

const detail = (): Promise<ApiResponse<UserModel>> => {
  return http.get(API_LIST.DETAIL_USER);
};
const changePassword = (data: ChangePasswordRequest): Promise<ApiResponse> =>
  http.post(API_LIST.CHANGE_PASSWORD, data);

export const userProfileService = {
  update,
  detail,
  changePassword,
};
